import React, { useContext, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Orders.module.sass";
import Card from "../../components/Card";
import Market from './Market'
import Dropdown from "../../components/Dropdown";
import { GlobalState } from "../../App";
import Form from "../../components/Form";


const Orders = () => {

  const { setOrdersFilterBy, ordersFilterBy } = useContext(GlobalState)
  const optionsStatus = ["Select status", "In Progress", "Extended", "Complete", "Cancelled", "All"]
  // const [orderStatus, setOrderStatus] = useStateWithCallbackLazy(optionsStatus[0])
  const [search, setSearch] = useState('')
  useEffect(() => {
    setOrdersFilterBy(optionsStatus[0])
  }, [])

  return (
    <>
      <Card
        className={styles.card}
        classCardHead={styles.head}
        title="All orders"
        classTitle={cn("title-purple", styles.title)}
        head={
          <div className={styles.card_header_container}>
            <Form
              className={styles.form}
              value={search}
              setValue={setSearch}
              placeholder="Search by id"
              type="text"
              name="search"
              icon="search"
            />

            <div className={styles.smallDropdownField}>
              <Dropdown
                className={styles.smallDropdownField}
                classDropdownLabel={styles.smallDropdownlabel}
                classDropdownHead={styles.dropdownHead}
                value={ordersFilterBy}
                setValue={setOrdersFilterBy}
                options={optionsStatus}
              />
            </div>
          </div>

        }
      >
        <div className={styles.wrapper}>
          <Market searchBy={search} ordersFilterBy={ordersFilterBy}  />
        </div>
      </Card>
    </>
  );
};

export default Orders;
